import React, { useState, useEffect } from 'react';
import styles from './Carousel.module.css';
import Button from '../button/Button';

export default function GalleryWithOverlay({ 
  images = [], 
  categories = null, 
  categoryTitle = "הגלריה המלאה",
  serviceName = "",
  defaultMessage = "היי בטי! הגעתי מהדף שלך, אשמח לשמוע עוד פרטים"
}) {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  
  const safeImages = images && images.length > 0 
    ? images 
    : ['https://via.placeholder.com/400x300?text=Image+1'];

  const mainImage = safeImages[0];

  // אתחול קטגוריה ראשונה
  useEffect(() => {
    if (categories && categories.length > 0 && !selectedCategory) {
      setSelectedCategory(categories[0].id);
    }
  }, [categories, selectedCategory]);

  // קביעת התמונות והמסר להצגה לפי קטגוריה
  const currentCategory = categories && selectedCategory
    ? categories.find(cat => cat.id === selectedCategory)
    : null;
    
  const displayImages = currentCategory?.images || safeImages;
  
  // אם יש קטגוריות ונבחרה קטגוריה - נשתמש בהודעה שלה
  // אם אין קטגוריות - נשתמש בהודעת ברירת המחדל
  const currentMessage = currentCategory?.message || defaultMessage;

  // נעילת גלילה כשהאוברליי פתוח
  useEffect(() => {
    if (isOverlayOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOverlayOpen]);

  // סגירה עם ESC
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && isOverlayOpen) {
        setIsOverlayOpen(false);
      }
    };
    
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOverlayOpen]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      setIsOverlayOpen(false);
    }
  };

  return (
    <>
      {/* תמונה ראשית עם כפתור */}
      <div className={styles.mainImageContainer}>
        <img 
          src={mainImage} 
          alt="תמונה ראשית"
          className={styles.mainImage}
        />
        <button 
          className={styles.glassButton}
          onClick={() => setIsOverlayOpen(true)}
        >
          לגלריה המלאה
        </button>
      </div>

      {/* Overlay עם הגלריה */}
      {isOverlayOpen && (
        <div 
          className={styles.overlay}
          onClick={handleOverlayClick}
        >
          <div className={styles.overlayContent}>
            {/* כפתור סגירה */}
            <button 
              className={styles.closeButton}
              onClick={() => setIsOverlayOpen(false)}
              aria-label="סגור"
            >
              ✕
            </button>

            {/* כותרת */}
            <h2 className={styles.galleryTitle}>{categoryTitle}</h2>

            {/* טאבים של קטגוריות */}
            {categories && categories.length > 0 && (
              <div className={styles.categoriesContainer}>
                {categories.map((category) => (
                  <button
                    key={category.id}
                    className={`${styles.categoryTab} ${selectedCategory === category.id ? styles.activeTab : ''}`}
                    onClick={() => setSelectedCategory(category.id)}
                  >
                    {category.name}
                  </button>
                ))}
              </div>
            )}

            {/* גלריית תמונות */}
            <div className={styles.galleryGrid}>
              {displayImages.map((image, index) => (
                <div key={index} className={styles.galleryItem}>
                  <img 
                    src={image} 
                    alt={`תמונה ${index + 1}`}
                    className={styles.galleryImage}
                  />
                </div>
              ))}
            </div>

            {/* כפתור CTA */}
            <div className={styles.ctaContainer}>
              <Button text="לעוד פרטים לחצי כאן" message={currentMessage} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}